import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyA4TawJqQ09qxsCUGgTtoN6Yje1n-DyewI",
  authDomain: "zondra-webapp.firebaseapp.com",
  databaseURL:
    "https://zondra-webapp-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "zondra-webapp",
  storageBucket: "zondra-webapp.appspot.com",
  messagingSenderId: "731945055163",
  appId: "1:731945055163:web:4c55217bd12736505cca9e",
  measurementId: "G-JWSQ53JEHR",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const storage = getStorage(app);

export { db, storage };
